import React, { useState, useEffect } from "react";
import { Routes, Route, useLocation, Link } from "react-router-dom";
import Login from "./components/Login";
import Game from "./components/Game";
import MultiplayerGame from "./components/MultiplayerGame";
import GameInvitations from "./components/GameInvitations";
import OnlineUsers from "./components/OnlineUsers";
import ThemeToggle from "./components/ThemeToggle";
import { ThemeProvider } from "./context/ThemeContext";
import "./styles/App.css";

// Icons for navigation
const HomeIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
    <polyline points="9 22 9 12 15 12 15 22"></polyline>
  </svg>
);

const GameIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"></circle>
    <line x1="14.31" y1="8" x2="20.05" y2="17.94"></line>
    <line x1="9.69" y1="8" x2="21.17" y2="8"></line>
    <line x1="7.38" y1="12" x2="13.12" y2="2.06"></line>
    <line x1="9.69" y1="16" x2="3.95" y2="6.06"></line>
    <line x1="14.31" y1="16" x2="2.83" y2="16"></line>
    <line x1="16.62" y1="12" x2="10.88" y2="21.94"></line>
  </svg>
);

const UsersIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
    <circle cx="9" cy="7" r="4"></circle>
    <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
    <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
  </svg>
);

const App = () => {
  const [currentUser, setCurrentUser] = useState(null);
  const location = useLocation();
  
  // Load user data from localStorage on component mount
  useEffect(() => {
    const userData = localStorage.getItem("user");
    if (userData) {
      try {
        const parsedUser = JSON.parse(userData);
        setCurrentUser(parsedUser);
      } catch (error) {
        console.error("Error parsing user data:", error);
      }
    }
  }, []);

  // Check if we're on the login page
  const isLoginPage = location.pathname === '/';
  // Check if we're on a multiplayer game page
  const isMultiplayerPage = location.pathname.startsWith('/multiplayer');

  return (
    <ThemeProvider>
      <div className="mobile-container">
        {!isLoginPage && (
          <header className="mobile-header">
            <div className="mobile-title">
              <h1 className="text-lg font-bold">Hangman</h1>
            </div>
            <div className="mobile-nav">
              <ThemeToggle />
            </div>
          </header>
        )}
        
        <main className="mobile-content">
          {/* Game invitations component appears globally */}
          <GameInvitations />
          
          {/* Show online users except on multiplayer game pages */}
          {currentUser && !isMultiplayerPage && !isLoginPage && (
            <OnlineUsers currentUser={currentUser} />
          )}
          
          <Routes>
            <Route path="/" element={<Login onUserLogin={setCurrentUser} />} />
            <Route path="/game" element={<Game />} />
            <Route path="/multiplayer/:gameId" element={<MultiplayerGame />} />
          </Routes>
        </main>
        
        {currentUser && !isLoginPage && (
          <footer className="mobile-footer">
            <Link to="/" className={`nav-button ${location.pathname === '/' ? 'active' : ''}`}>
              <HomeIcon />
              <span>Home</span>
            </Link>
            <Link to="/game" className={`nav-button ${location.pathname === '/game' ? 'active' : ''}`}>
              <GameIcon />
              <span>Play</span>
            </Link>
            {!isMultiplayerPage && (
              <div className="nav-button">
                <UsersIcon />
                <span>Friends</span>
              </div>
            )}
          </footer>
        )}
      </div>
    </ThemeProvider>
  );
};

export default App;
